import React from 'react';
interface ContentSectionProps {
  title: string;
  content: ReactNode;
  bgColor?: string;
  titleClass?: string;
  containerClass?: string;
}
export function ContentSection({
  title,
  content,
  bgColor = 'bg-white',
  titleClass = 'text-2xl md:text-3xl text-gray-900',
  containerClass = ''
}: ContentSectionProps) {
  return <section className={`w-full py-6 ${bgColor} rounded-lg my-5 ${containerClass}`} data-id="element-211">
      <div className="max-w-3xl mx-auto" data-id="element-212">
        <h2 className={`font-bold mb-5 leading-tight ${titleClass}`} data-id="element-213">
          {title}
        </h2>
        <div className="text-lg" data-id="element-214">{content}</div>
      </div>
    </section>;
}